export class ExperimentalDesignTypeEnum {
    static readonly RANDOMIZED_COMPLETE_BLOCK = new ExperimentalDesignTypeEnum(0, 10110, 'study-editor.experiment-design.rcbd');
    static readonly RESOLVABLE_INCOMPLETE_BLOCK = new ExperimentalDesignTypeEnum(1, 10130, 'study-editor.experiment-design.ribd');
    static readonly RESOLVABLE_INCOMPLETE_BLOCK_LATINIZED = new ExperimentalDesignTypeEnum(1, 10166, 'study-editor.experiment-design.ribl', null, true);
    static readonly ROW_COL = new ExperimentalDesignTypeEnum(2, 10145, 'study-editor.experiment-design.rcd');
    static readonly ROW_COL_LATINIZED = new ExperimentalDesignTypeEnum(2, 10167, 'study-editor.experiment-design.rcdl', null, true);
    static readonly CUSTOM_IMPORT = new ExperimentalDesignTypeEnum(3, 10168, 'study-editor.experiment-design.cid');
    static readonly AUGMENTED_RANDOMIZED_BLOCK = new ExperimentalDesignTypeEnum(4, 10160, 'study-editor.experiment-design.arbd');
    static readonly ENTRY_LIST_ORDER = new ExperimentalDesignTypeEnum(5, 10169, 'study-editor.experiment-design.elo');
    static readonly P_REP = new ExperimentalDesignTypeEnum(6, 10164, 'study-editor.experiment-design.prep');

    constructor(
        readonly id: number,
        readonly termId: number,
        readonly name: string,
        readonly params?: string,
        readonly latinized?: boolean,
    ) {
    }

    static getByTermId(termId: number | string): ExperimentalDesignTypeEnum | null {
        if (termId !== null && termId !== undefined) {
            const obj = Object.values(ExperimentalDesignTypeEnum).find(type => type.termId.toString() === termId.toString());
            if (obj) {
                return obj;
            }
        }

        return null;
    }

    static getById(id: number | string): ExperimentalDesignTypeEnum | null {
        if (id !== null && id !== undefined) {
            const obj = this.getValues().find(type => type.id.toString() === id.toString());
            if (obj) {
                return obj;
            }
        }
        return null;
    }

    static getValues(): ExperimentalDesignTypeEnum[] {
        return Object.values(ExperimentalDesignTypeEnum).filter(type => type.latinized !== true && type.id !== 3);
    }
}
